import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ConfigTemplateFieldComponent } from './config-template-field.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    ConfigTemplateFieldComponent,
  ],
  exports: [
    ConfigTemplateFieldComponent,
  ],
})
export class ConfigTemplatesExportModule {}
